import { Typography, Divider } from "antd";
import dayjs from "dayjs";
import { getPluralizedWord } from "@/utils";
import { DATE_FORMAT, PLURALIZATION_WORDS } from "@/constants/repeats";

const { Text } = Typography;

const TaskDurationInfo = ({
  task,
  taskDurationDays,
  taskDurationWorksDays,
}) => {
  if (!taskDurationDays) return null;

  return (
    <>
      <Text>
        Продолжительность задачи {taskDurationDays}{" "}
        {getPluralizedWord(taskDurationDays, PLURALIZATION_WORDS.DAYS)} (
        {taskDurationWorksDays}{" "}
        {getPluralizedWord(
          taskDurationWorksDays,
          PLURALIZATION_WORDS.WORK_DAYS
        )}
        ). С {dayjs(task.start_date).format(DATE_FORMAT)} по{" "}
        {dayjs(task.due_date).format(DATE_FORMAT)}
      </Text>

      <Divider style={{ borderColor: "var(--color-gray)" }} />
    </>
  );
};

export default TaskDurationInfo;
